import React, { useMemo } from 'react';
import DocViewer, { DocViewerRenderers, IHeaderOverride } from 'react-doc-viewer';
import styled from 'styled-components';

type DocUrl = {
  uri: string;
};
type Variant = 'light'
type Props = {
  urlList?: DocUrl[];
  height?: string;
  headerComponent?: IHeaderOverride;
  previewUrl?: string;
  variant?: Variant
};
const StyledDocViewer = styled(DocViewer)<{ height?: string; variant?: Variant }>`
  height: ${({ height }) => height || '65vh'};
  ${({ variant }) => {
    switch (variant) {
      case 'light':
        return `
        background: #fff;
          .react-pdf__Document, 
          .pdf-page-wrapper {
            margin: 0;
          }
        `;
      default:
        return '';
    }
  }}
`;

function DefaultHeader() {
  return <></>;
}
const FileViewer = ({
  urlList = [],
  height,
  headerComponent,
  variant,
  previewUrl = ''
}: Props): JSX.Element => {
  const fileUrl = useMemo(() => [{ uri: previewUrl }], [previewUrl]);
  return (
    <StyledDocViewer
      config={{
        header: {
          overrideComponent: headerComponent || DefaultHeader
        }
      }}
      height={height}
      documents={previewUrl ? fileUrl : urlList}
      pluginRenderers={DocViewerRenderers}
      variant={variant}
    ></StyledDocViewer>
  );
};

export default FileViewer;
